<template>
  <div
    id="integrationSetting"
    class="mx-5"
  >
    <div class="mt-2 ml-3 d-flex justify-space-between">
      <div>
        <h2>Add Custom Field Mapping</h2>
        <p class="my-4 text--disabled">
          Add upto 50 custom fields for mappings for your Zapier integration.
        </p>
      </div>
      <v-col cols="1">
        <v-btn
          id="close-zapier-drawer"
          v-track="'close-zapier-drawer'"
          class="text-right mt-3"
          icon
          @click.stop="
            $store.commit('ui/drawer.right.toggle')
          "
        >
          <v-icon
            style="background-color:transparent"
            medium
          >
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </div>
    <v-col cols="4">
      <div class="d-flex justify-space-between">
        <v-btn
          id="close-zapier-drawer"
          v-track="'close-zapier-drawer'"
          outlined
          class="text-capitalize"
          @click.stop="$store.commit('ui/drawer.right.toggle')"
        >
          Cancel
        </v-btn>
        <v-btn
          id="update-zapier-fields"
          v-track="'update-zapier-fields'"
          dark
          class="text-capitalize mr-3"
          :loading="isUpdating"
          @click="updateCustomFieldMappings"
        >
          Save
        </v-btn>
      </div>
    </v-col>
    <div class="mx-3">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <div class="mt-0">
          <v-row class="align-center">
            <v-col cols="3">
              <div class="pb-1 font-weight-medium">
                Zapier Source
              </div>
              <v-divider class="pb-1" />
            </v-col>
            <v-col cols="9">
              <div class="pb-1 font-weight-medium">
                Maropost Target
              </div>
              <v-divider class="pb-1" />
            </v-col>
          </v-row>
          <v-row
            v-for="(field, index) in fields"
            :key="index"
            class="align-center pb-4"
          >
            <v-col
              class="py-0"
              cols="3"
            >
              <div class="font-weight-light text-capitalize">
                {{ fieldObject(field).replace(/_/g, " ") }}
              </div>
            </v-col>
            <v-col
              class="py-0"
              cols="9"
            >
              <v-autocomplete
                :id="`select-zapier-field-${fieldObject(field)}`"
                :v-track="`select-zapier-field-${fieldObject(field)}`"
                label="Target"
                v-model="fields[index][fieldObject(field)]"
                item-text="name"
                item-value="id"
                :items="customFields"
                outlined
                required
                clearable
                class="custom-selectbox"
                item-color="#03B6FC"
                light
                hide-details
                no-data-text
              >
                <template #append-item>
                  <create-list-option
                    item-text="CREATE NEW CUSTOM FIELD"
                    @open-list="openList(fieldObject(field))"
                  />
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </div>
    <!-- Create new custom field dialog -->
    <v-dialog
      v-model="showCreateCustomFieldPrompt"
      width="700"
    >
      <custom-fields-drawer
        isbg-white
        is-dialog
        @close-drawer="closeDrawer"
      />
    </v-dialog>
  </div>
</template>

<script>
  import { $integrations } from '@/services'
  import CustomFieldsDrawer from '@/views/drawers/CustomFieldsDrawer'
  import CreateListOption from '@/components/shared/CreateListOption'

  export default {
    name: 'ZapierIntegrationDrawer',
    components: {
      CustomFieldsDrawer,
      CreateListOption,
    },
    data () {
      return {
        payload: {
          sync_old_data: true,
        },
        valid: true,
        enableScroll: true,
        page: 0,
        selectorClass: '',
        editingStoreId: null,
        showCreateCustomFieldPrompt: false,
        addFieldTargetNameField: '',
        isUpdating: false
      }
    },
    computed: {
      fields () {
        return this.$store.getters['ui/drawer'].right.mappingFields
      },
      customFields () {
        return this.$store.getters['ui/drawer'].right.customFields
      },
      fieldObject () {
        return field => {
          return Object.keys(field)[0]
        }
      },
      accountSettingId () {
        return this.$store.state.auth.packageFeatures.account_setting.id
      },
    },
    methods: {
      updateCustomFieldMappings () {
        this.isUpdating = true;
        const payload = Object.assign({}, ...this.fields)
        Object.keys(payload).forEach(key => {
          if(payload[key] == undefined){
            payload[key] = 0;
          }
        });
        $integrations.updateZapierFieldsList(this.accountSettingId, { mapped_custom_fields: payload }).then(() => {
          this.isUpdating = false;
          this.$store.commit('ui/snackbar', {
            message: 'Custom field mappings was successfully added.',
            type: 'success',
          });
          this.$router.push({ name: 'Zapier_index', query: { edit: new Date().getTime() } })
        })
      },
      openList (field) {
        this.showCreateCustomFieldPrompt = true
        this.addFieldTargetNameField = field
      },
      closeDrawer (data) {
        if (data) {
          const tempCustomFields = this.customFields
          const tempMappedFields = this.fields
          tempCustomFields.push(data.data)
          var createdFieldMapping = new Promise((resolve, reject) => {
            tempMappedFields.forEach(async (field, index) => {
              if (this.fieldObject(field) == this.addFieldTargetNameField) {
                tempMappedFields[index][this.addFieldTargetNameField] = data.data.id
              }
              if (index === tempMappedFields.length - 1) resolve()
            })
          })
          createdFieldMapping.then(() => {
            this.$store.commit('ui/drawer.right', {
              component: 'ZapierIntegrationDrawer',
              show: true,
              width: '700px',
              mappingFields: tempMappedFields,
              customFields: tempCustomFields,
            })
            this.showCreateCustomFieldPrompt = false
          })
        }
      },
    },
  }
</script>

<style scoped>
.bg-grey{
  background-color: #F4F4F4;
}
.mt-55{
  margin-top: 55px !important;
}
</style>
